import { reject } from 'es-toolkit/compat';

import * as Dashboard from 'types';
import { safeToNumber, toJSON } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';
import ClowncarAppConstants from 'constants/ClowncarAppConstants';

interface InitialState {
  businessOnboardingSalesforce?: Dashboard.dashboard.BusinessOnboardingSalesforce;
  guessedTimeZone?: string;
  isInitialized: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onboardings: any[];
  requestInProgress: boolean;
}

const initialState: InitialState = {
  businessOnboardingSalesforce: undefined,
  guessedTimeZone: undefined,
  isInitialized: false,
  onboardings: [],
  requestInProgress: false,
};

export default function reducer(state = initialState, action: BaseTockAction) {
  const { type, payload } = action;
  switch (type) {
    case ClowncarAppConstants.ONBOARDING_CREATE_STARTING:
    case ClowncarAppConstants.ONBOARDING_FETCH_ALL_STARTING: {
      return {
        ...state,
        requestInProgress: true,
      };
    }

    case ClowncarAppConstants.ONBOARDING_FETCH_ALL_DONE: {
      return {
        ...state,
        isInitialized: true,
        onboardings: payload,
        requestInProgress: false,
      };
    }

    case ClowncarAppConstants.ONBOARDING_REMOVE: {
      const onboardingId = payload;
      return {
        ...state,
        onboardings: reject(
          state.onboardings,
          (onboarding) => safeToNumber(onboarding.id) === safeToNumber(onboardingId)
        ),
      };
    }

    case ClowncarAppConstants.ONBOARDING_SALESFORCE_GET_BUSINESS_STARTING: {
      return {
        ...state,
        requestInProgress: true,
        isInitialized: false,
      };
    }
    case ClowncarAppConstants.ONBOARDING_SALESFORCE_GET_BUSINESS_FAILED: {
      return {
        ...state,
        isInitialized: true,
        requestInProgress: false,
      };
    }

    case ClowncarAppConstants.ONBOARDING_SALESFORCE_GET_BUSINESS_DONE: {
      return {
        ...state,
        businessOnboardingSalesforce: toJSON(payload),
        isInitialized: true,
        requestInProgress: false,
      };
    }

    case AppConstants.ONBOARDING_FETCH_TIME_ZONE_DONE: {
      return {
        ...state,
        guessedTimeZone: payload.timeZoneId,
      };
    }

    case ClowncarAppConstants.ONBOARDING_CREATE_FAILED:
    case ClowncarAppConstants.ONBOARDING_CREATE_DONE: {
      return {
        ...state,
        requestInProgress: false,
      };
    }
    default:
      return state;
  }
}
